export var BaseCurrencies;
(function (BaseCurrencies) {
    BaseCurrencies["STEEM"] = "steem";
    BaseCurrencies["SBD"] = "sbd";
    BaseCurrencies["HIVE"] = "hive";
    BaseCurrencies["HBD"] = "hbd";
    BaseCurrencies["BLURT"] = "blurt";
    BaseCurrencies["TIME"] = "time";
})(BaseCurrencies || (BaseCurrencies = {}));
const getCurrencyLabels = (isTestnet) => {
    return {
        steem: isTestnet ? 'TESTS' : 'STEEM',
        sbd: isTestnet ? 'TBD' : 'SBD',
        sp: isTestnet ? 'TP' : 'SP',
        hive: isTestnet ? 'TESTS' : 'HIVE',
        hbd: isTestnet ? 'TBD' : 'HBD',
        hp: isTestnet ? 'hP' : 'HP',
        blurt: isTestnet ? 'TESTS' : 'BLURT',
        bp: isTestnet ? 'BP' : 'BP',
        time: isTestnet ? 'TIME' : 'TIME',
    };
};
const getCurrencyLabel = (currency, isTestnet) => {
    const cur = currency.toLowerCase();
    const label = getCurrencyLabels(isTestnet)[cur];
    if (currency.toLowerCase() === 'time') {
        return currency.toUpperCase();
    }
    else {
        return label ? label : cur.toUpperCase();
    }
};
const CurrencyUtils = {
    getCurrencyLabels,
    getCurrencyLabel,
};
export default CurrencyUtils;
